/**
 * Declarative `data-track-*` attributes for Mixpanel autocapture.
 *
 * We don't emit custom events for clicks. Author these attributes directly on
 * any element (any design-system component that forwards DOM props):
 *
 * @example
 * <Button
 *   data-track-name="back-to-location"   // stable kebab-case id you analyze by
 *   data-track-label="Back to location"  // human-readable label (optional)
 *   data-track-context="booking-dialog" // surface/context, kebab-case (optional)
 * >
 *   Back
 * </Button>
 *
 * Mixpanel autocapture records them as `$el_attr__data-track-*` properties on
 * `[Auto] Element Click` — wired via the SDK's `autocapture.capture_extra_attrs`,
 * fed by {@link TRACK_DATA_ATTRIBUTES}. All attributes are optional enrichment;
 * their presence does not gate capture (clicks fire on every element regardless).
 *
 * Single source of truth: keep this list in sync with the attributes you author.
 */
const TRACK_DATA_ATTRIBUTES = [
  "data-track-name",
  "data-track-label",
  "data-track-context",
] as const;

export { TRACK_DATA_ATTRIBUTES };
